import { FC } from 'react'
import { CustomSelectFieldGroup } from '@components-v2/molecules/CustomSelectFieldGroup'

type Value = {
  minAmount?: string
  maxAmount?: string
}

type Props = {
  placeholder: string
  selectedValue: Value
  setFieldValue: (value: Value) => void
}

export const InvestmentTargetAmountSelectField: FC<Props> = ({ placeholder, selectedValue, setFieldValue }) => {
  const onSelect = (id: string) => {
    const item = allItems.find((i) => i.id === id)
    if (!item) {
      return
    }

    setFieldValue(item.value)
  }

  const onUnselect = () => {
    setFieldValue(undefined)
  }

  const allItems = [
    { id: '-10', name: '~10K', value: { maxAmount: '10000' } },
    { id: '10-50', name: '10K~50K', value: { minAmount: '10000', maxAmount: '50000' } },
    { id: '50-100', name: '50K~100K', value: { minAmount: '50000', maxAmount: '100000' } },
    { id: '100-500', name: '100K~500K', value: { minAmount: '100000', maxAmount: '500000' } },
    { id: '500-', name: '500K~', value: { minAmount: '500000' } },
  ]

  const selectedItem = selectedValue
    ? allItems.find((item) => {
        if (selectedValue.minAmount && selectedValue.maxAmount) {
          return item.value.minAmount === selectedValue.minAmount && item.value.maxAmount === selectedValue.maxAmount
        }

        if (selectedValue.minAmount) {
          return item.value.minAmount === selectedValue.minAmount
        }

        if (selectedValue.maxAmount) {
          return item.value.maxAmount === selectedValue.maxAmount
        }

        return false
      })
    : undefined

  const selectableItems = allItems.map((item) => ({
    instance: item,
    isSelected: selectedItem && selectedItem.id === item.id,
  }))

  return (
    <CustomSelectFieldGroup
      placeholder={placeholder}
      onSelect={onSelect}
      onUnselect={onUnselect}
      selectedItems={selectedItem ? [selectedItem] : []}
      selectableItems={selectableItems}
      onUnselectAll={onUnselect}
    />
  )
}
